import { render, staticRenderFns } from "./UserDetailModal.vue?vue&type=template&id=01edf286&scoped=true"
import script from "./UserDetailModal.vue?vue&type=script&lang=js"
export * from "./UserDetailModal.vue?vue&type=script&lang=js"
import style0 from "./UserDetailModal.vue?vue&type=style&index=0&id=01edf286&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01edf286",
  null
  
)

export default component.exports